import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";
import { AcdQueuesPageComponent } from "./acdQueuesPage/acd-queues-page.component";
import { AcdQueuesShelfComponent } from "./acdQueuesShelfContainer/acd-queues-shelf-container.component";
import { AcdQueuesBasicTabComponent } from "./acdQueuesShelfContainer/acdQueuesBasicSettings/acd-queues-basic-settings-tab.component";
import { AcdQueuesAgentTabComponent } from "./acdQueuesShelfContainer/acdQueuesAgentSettings/acd-queues-agent-settings-tab.component";
import { AcdQueuesCallerTabComponent } from "./acdQueuesShelfContainer/acdQueuesCallerSettings/acd-queues-caller-settings-tab.component";
import { AcdQueuesEnhancedTabComponent } from "./acdQueuesShelfContainer/acdQueuesEnhancedQueue/acd-queues-enhanced-tab.component";
import { AcdQueuesBasicViewComponent } from "./acdQueuesShelfContainer/acdQueuesBasicSettings/acdQueuesBasicSettingsView/acd-queues-basic-settings-view.component";
import { AcdQueuesBasicEditComponent } from "./acdQueuesShelfContainer/acdQueuesBasicSettings/acdQueuesBasicSettingsEdit/acd-queues-basic-settings-edit.component";
import { AcdQueuesAgentViewComponent } from "./acdQueuesShelfContainer/acdQueuesAgentSettings/acdQueuesAgentSettingsView/acd-queues-agent-settings-view.component";
import { AcdQueuesAgentEditComponent } from "./acdQueuesShelfContainer/acdQueuesAgentSettings/acdQueuesAgentSettingsEdit/acd-queues-agent-settings-edit.component";
import { AcdQueuesCallerViewComponent } from "./acdQueuesShelfContainer/acdQueuesCallerSettings/acdQueuesCallerSettingsView/acd-queues-caller-settings-view.component";
import { AcdQueuesCallerEditComponent } from "./acdQueuesShelfContainer/acdQueuesCallerSettings/acdQueuesCallerSettingsEdit/acd-queues-caller-settings-edit.component";
import { AcdQueuesEnhancedViewComponent } from "./acdQueuesShelfContainer/acdQueuesEnhancedQueue/acdQueuesEnhancedQueueView/acd-queues-enhanced-view.component";
import { AcdQueuesEnhancedEditComponent } from "./acdQueuesShelfContainer/acdQueuesEnhancedQueue/acdQueuesEnhancedQueueEdit/acd-queues-enhanced-edit.component";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { EditItemListModule } from "@onsip/web/features/shared/components/onsipItemList/edit-item-list.module";
import { SelectionListDeluxeModule } from "@onsip/web/features/shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { FormEventTrackingModule } from "@onsip/web/features/shared/components/analytics/form-event-tracking.module";
import { AddressAutocompleteModule } from "../addressAutocomplete/address-autocomplete.module";
import { ListPickerModule } from "@onsip/web/features/shared/components/pickers/listPicker/list-picker.module";
import { AcdQueuesRoutingModule } from "./acd-queues-routing-module";
import { AddStorageServiceDialogComponent } from "./addStorageServiceDialog/add-storage-service-dialog.component";
import { AcdQueuesSetupComponent } from "./acdQueuesSetup/acd-queues-setup.component";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { PhoneNumberListModule } from "../../shared/components/phoneNumberList/phone-number-list.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { LayoutModule } from "@onsip/web/features/shared/components/layout/layout.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatSortModule } from "@angular/material/sort";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatCardModule } from "@angular/material/card";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDividerModule } from "@angular/material/divider";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatListModule } from "@angular/material/list";
import { AcdQueuesEmptyDataComponent } from "./acd-queues-empty-data/acd-queues-empty-data.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PipesModule,
    OnsipFormsModule,
    RouterModule,
    TableModule,
    EditItemListModule,
    SelectionListDeluxeModule,
    FormEventTrackingModule,
    AddressAutocompleteModule,
    ListPickerModule,
    AcdQueuesRoutingModule,
    SipAddressFieldModule,
    ExtensionsListModule,
    PhoneNumberListModule,
    TableDataLoadContainerModule,
    LayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSortModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatDividerModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatListModule,
    LoadingContainerComponent
  ],
  declarations: [
    AcdQueuesPageComponent,
    AcdQueuesSetupComponent,
    AcdQueuesShelfComponent,
    AcdQueuesBasicTabComponent,
    AcdQueuesAgentTabComponent,
    AcdQueuesCallerTabComponent,
    AcdQueuesEnhancedTabComponent,
    AcdQueuesBasicViewComponent,
    AcdQueuesBasicEditComponent,
    AcdQueuesAgentViewComponent,
    AcdQueuesAgentEditComponent,
    AcdQueuesCallerViewComponent,
    AcdQueuesCallerEditComponent,
    AcdQueuesEnhancedViewComponent,
    AcdQueuesEnhancedEditComponent,
    AddStorageServiceDialogComponent,
    AcdQueuesEmptyDataComponent
  ]
})
export class AcdQueuesModule {}
